import { Icon } from '@iconify/react';
import React, { useEffect, useState } from 'react';
import { pageTitle } from '../../helper';
import axios from 'axios';
import Button from '../Button';
import Cta from '../Cta';
import Div from '../Div';
import PageHeading from '../PageHeading';
import Spacing from '../Spacing';
import BASE_URL from '../../utils/api';
import Swal from '../../utils/darkSwal';


export default function AllJobs() {
  pageTitle('Available Job Listings');

  const [selected, setSelected] = useState(null);
  const [jobs, setJobs] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [applyJobId, setApplyJobId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [formData, setFormData] = useState({
    applicantName: '',
    applicantEmail: '',
    applicantExperience: [''],
    expectedSalary: '',
    applicantDes: '',
    applicantCV: null
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    axios.get(`${BASE_URL}/api/jobs/active`)
      .then(res => setJobs(res.data))
      .catch(err => console.error('Failed to fetch jobs', err));
  }, []);


  const filteredJobs = jobs.filter(job =>
    job.jobName.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleExperienceChange = (i, value) => {
    const updated = [...formData.applicantExperience];
    updated[i] = value;
    setFormData(prev => ({ ...prev, applicantExperience: updated }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === 'application/pdf') {
      setFormData(prev => ({ ...prev, applicantCV: file }));
    } else {
      Swal.fire({
        icon: 'warning',
        title: 'Invalid File Type',
        text: 'Only PDF files are allowed.',
        confirmButtonColor: '#f27474',
      });
    }
  };

  const handleSubmit = async (jobId) => {
  const token = localStorage.getItem('token');
  const data = new FormData();

  data.append('jobId', jobId);
  data.append('applicantName', formData.applicantName);
  data.append('applicantEmail', formData.applicantEmail);
  data.append('expectedSalary', formData.expectedSalary);
  data.append('applicantDes', formData.applicantDes);
  formData.applicantExperience.forEach(exp => data.append('applicantExperience', exp));
  if (formData.applicantCV) data.append('applicantCV', formData.applicantCV);

  try {
    setSubmitting(true);
    await axios.post(`${BASE_URL}/api/jobApplications`, data, {
      headers: { Authorization: `Bearer ${token}` }
    });

    Swal.fire({
      icon: 'success',
      title: 'Application Submitted!',
      text: 'Your job application has been sent successfully.',
      confirmButtonColor: '#3085d6',
    });

    setApplyJobId(null);
    setFormData({
      applicantName: '',
      applicantEmail: '',
      applicantExperience: [''],
      expectedSalary: '',
      applicantDes: '',
      applicantCV: null
    });
  } catch (err) {
    Swal.fire({
      icon: 'error',
      title: 'Submission Failed',
      text: 'There was a problem submitting your application. Please try again.',
      confirmButtonColor: '#d33',
    });
    console.error(err);
  } finally {
    setSubmitting(false);
  }
};

  const handleApplyClick = (jobId, index) => {
    setSelected(index);
    setApplyJobId(jobId);
  };

  return (
    <>
      <PageHeading
        title="Come Build the Future with Us"
        bgSrc="/images/about_hero_bg.jpeg"
        pageLinkText="Jobs"
      />
      <Spacing lg="150" md="80" />
      <Div className="container">
        <Div className="row">
          <Div className="col-lg-4">
            <Div className="cs-faq_nav cs-radius_15">
              <h2 className="cs-faq_nav_title cs-m0">Search Jobs</h2>
              <Div className="cs-height_20" />
              <input
                type="text"
                className="form-control"
                placeholder="Search by title..."
                value={searchQuery}
                onChange={e => setSearchQuery(e.target.value)}
              />
            </Div>
          </Div>

          <Div className="col-lg-7 offset-lg-1">
            <Spacing lg="0" md="40" />
            <Div className="cs-accordians cs-style1">
              {filteredJobs.length > 0 ? (
                filteredJobs.map((job, index) => (
                  <Div className={`cs-accordian ${selected === index ? 'active' : ''}`} key={job._id}>
                    <Div
                      className="cs-accordian_head"
                      onClick={() => setSelected(index)}
                      style={{ cursor: 'pointer' }}
                    >
                      <h2 className="cs-accordian_title">{job.jobName}</h2>
                    </Div>
                    <Div className="cs-accordian_body">
                      <Div className="cs-accordian_body_in">
                        <img
                          src={job.jobImg}
                          alt={job.jobName}
                          style={{ width: '100%', maxHeight: '250px', objectFit: 'cover', borderRadius: '10px', marginBottom: '1rem' }}
                        />
                        <p><strong>Description:</strong> {job.jobDescription}</p>
                        <p><strong>Salary:</strong> Rs. {parseFloat(job.salary?.$numberDecimal || 0).toLocaleString()}</p>
                        <p><strong>Requirements:</strong></p>
                        <ul>
                          {job.jobRequirements.map((req, i) => (
                            <li key={i}>– {req}</li>
                          ))}
                        </ul>
                        <p><strong>Posted by:</strong> {job.createBy?.userName}</p>
                        <Spacing lg="20" />
                        <Button
                            variant="cs-type1"
                            btnText="Apply Now"
                            className="cs-btn cs-style1"
                            onClick={() => handleApplyClick(job._id, index)}
                            icon={<Icon icon="material-symbols:send-rounded" />}
                          />
                        {String(applyJobId) === String(job._id) && (
                          <form
                            onSubmit={(e) => {
                              e.preventDefault();
                              handleSubmit(job._id);
                            }}
                            style={{ marginTop: '20px' }}
                          >
                            <input
                              type="text"
                              className="form-control mb-2"
                              name="applicantName"
                              placeholder="Your Name"
                              value={formData.applicantName}
                              onChange={handleChange}
                              required
                            />
                            <input
                              type="email"
                              className="form-control mb-2"
                              name="applicantEmail"
                              placeholder="Your Email"
                              value={formData.applicantEmail}
                              onChange={handleChange}
                              required
                            />
                            {formData.applicantExperience.map((exp, i) => (
                              <input
                                key={i}
                                type="text"
                                className="form-control mb-2"
                                placeholder={`Experience #${i + 1}`}
                                value={exp}
                                onChange={(e) => handleExperienceChange(i, e.target.value)}
                                required
                              />
                            ))}
                            <Button
                              type="button"
                              btnText="Add More Experience"
                              onClick={() =>
                                setFormData(prev => ({
                                  ...prev,
                                  applicantExperience: [...prev.applicantExperience, '']
                                }))
                              }
                              variant="cs-type2"
                              className="cs-btn cs-style1"
                            />
                            <Spacing lg="10" md="10" />
                            <input
                              type="number"
                              className="form-control mb-2"
                              name="expectedSalary"
                              placeholder="Expected Salary"
                              value={formData.expectedSalary}
                              onChange={handleChange}
                            />
                            <textarea
                              className="form-control mb-2"
                              name="applicantDes"
                              placeholder="Short description about yourself"
                              value={formData.applicantDes}
                              onChange={handleChange}
                            />
                            <input
                              type="file"
                              className="form-control mb-2"
                              accept=".pdf"
                              onChange={handleFileChange}
                              required
                              
                            />
                            <div>
                              <Button
                                type="submit"
                                btnText={submitting ? "Submitting..." : "Submit Application"}
                                variant="cs-type1"
                                disabled={submitting}
                                className="cs-btn cs-style3"
                              />
                            </div>
                            <Spacing lg="10" md="10" />
                            <div>
                              <Button
                                type="button"
                                btnText="Cancel Application"
                                onClick={() => setApplyJobId(null)}
                                variant="cs-type2"
                                className="cs-btn cs-style2"
                              />
                            </div>  
                          </form>
                        )}
                      </Div>
                    </Div>
                  </Div>
                ))
              ) : (
                <p>No jobs match your search.</p>
              )}
            </Div>
          </Div>
        </Div>
      </Div>

      <Spacing lg="150" md="80" />
      <Div className="container">
        <Cta
          title="Together, We Can Build Something <br/> <i> Great</i>?"
          btnText="Contact Our Experts "
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
    </>
  );
}